// Sesión local del rol "admin" del HCE (Rediseño mayor 2026-08-31, Módulos
// C/D/E) — el token nunca es de Medplum (ver lib/hce-auth.ts en la bóveda),
// así que vive en su propio par de claves de localStorage, no en el
// storagePrefix '@medplum:' que usa MedplumClient.
const HCE_ADMIN_TOKEN_KEY = 'hce-admin-token';
const HCE_ADMIN_TENANT_KEY = 'hce-admin-tenant-slug';

export function guardarSesionHceAdmin(token: string, subdominio: string): void {
  localStorage.setItem(HCE_ADMIN_TOKEN_KEY, token);
  localStorage.setItem(HCE_ADMIN_TENANT_KEY, subdominio);
}

export type SesionHceAdmin = { token: string; subdominio: string };

let ultimaSesion: SesionHceAdmin | null = null;

/**
 * Devuelve el MISMO objeto mientras la sesión guardada no cambie. Las
 * pantallas de admin lo llaman en cada render y lo usan como dependencia de
 * useCallback/useEffect: un objeto nuevo por render las hacía recargar sin
 * parar. Bug real 2026-09-13: el panel de Usuarios pedía /api/hce/usuarios
 * ~125 veces por segundo y dejaba al navegador sin conexiones libres (el
 * login y los botones "no hacían nada").
 */
export function leerSesionHceAdmin(): SesionHceAdmin | null {
  const token = localStorage.getItem(HCE_ADMIN_TOKEN_KEY);
  const subdominio = localStorage.getItem(HCE_ADMIN_TENANT_KEY);
  if (!token || !subdominio) return null;
  if (ultimaSesion?.token !== token || ultimaSesion.subdominio !== subdominio) ultimaSesion = { token, subdominio };
  return ultimaSesion;
}

export function cerrarSesionHceAdmin(): void {
  localStorage.removeItem(HCE_ADMIN_TOKEN_KEY);
  localStorage.removeItem(HCE_ADMIN_TENANT_KEY);
}
